module.exports = __webpack_public_path__ + "fonts/9af2c8229ee8c5a957977faaf8d5a608.svg";